import {QuestionChoiceTypeEnum} from '#apollo/schema';
import {ProgressBar, Text} from '#component/base';
import {QuestionControls} from '#component/partial/Wizard/component';

import {RatingSelect} from './RatingSelect/RatingSelect';

import {QuestionsProps} from './Questions.types';

import * as css from './Questions.css';

export const Questions = ({
  questions,
  questionSelected,
  valueQuestions,
  nextQuestion,
  backQuestion,
  editQuestion,
}: QuestionsProps) => {
  const questionIndex = questions.findIndex(item => item.id === questionSelected);
  const progress = questionIndex + 1;
  const isLastQuestion = questionIndex === questions.length - 1;
  const {id, text, multipleChoiceConfiguration} = questions[questionIndex];
  const {answerOptionIds} = valueQuestions[questionIndex];
  const fullWidthOption = id === 'question-ob-1';
  const isMultipleChoice =
    questions[questionIndex].multipleChoiceConfiguration?.questionChoiceType ===
    QuestionChoiceTypeEnum.MultiEnum;

  return (
    <div className={css.question}>
      <RatingSelect
        title={text || ''}
        scaleFromLabel={multipleChoiceConfiguration?.scale?.from}
        scaleToLabel={multipleChoiceConfiguration?.scale?.to}
        indexQuestion={questionIndex}
        options={multipleChoiceConfiguration?.options || []}
        value={answerOptionIds}
        editQuestion={editQuestion}
        fullWidthOption={fullWidthOption}
        isMultipleChoice={isMultipleChoice}
      />
      <div className={css.questionControlsDiv}>
        <QuestionControls
          hiddenBack={questionIndex + 1 === 1}
          onNext={nextQuestion}
          onBack={backQuestion}
          disabledNext={answerOptionIds.length === 0}
          nextLabel={isLastQuestion ? 'Finish' : undefined}
        />
      </div>
      <div className={css.infoProgress}>
        <Text className={css.textProgress} fontWeight="medium" color="doveGray">
          {progress} of {questions.length} Questions
        </Text>
        <ProgressBar value={progress} maxValue={questions.length} />
      </div>
    </div>
  );
};
